import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getPerformance } from "firebase/performance";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import {
  initializeFirestore,
  persistentLocalCache,
} from "firebase/firestore";
import { initializeFirebaseAppCheck } from "./appCheck";

const PROD_CONFIG = {
  apiKey: "AIzaSyANp8HyBcmv3OEo6JRxKu3MVr-0zOrsy4Q",
  authDomain: "notetaking-ai.firebaseapp.com",
  databaseURL: "https://notetaking-ai-default-rtdb.firebaseio.com",
  projectId: "notetaking-ai",
  storageBucket: "notetaking-ai.firebasestorage.app",
  messagingSenderId: "1049199961554",
  appId: "1:1049199961554:web:ec62b3fec4ca0f512f940b",
};

const DEV_PROJECT_ID = "tidle-development";
const DEV_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_DEV_API_KEY || "",
  authDomain: `${DEV_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${DEV_PROJECT_ID}-default-rtdb.firebaseio.com`,
  projectId: DEV_PROJECT_ID,
  storageBucket: `${DEV_PROJECT_ID}.firebasestorage.app`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_DEV_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_DEV_APP_ID || "",
};

function getSelectedBackend() {
  try {
    return localStorage.getItem("tidle-firebase-backend") === "prod" ? "prod" : "dev";
  } catch {
    return "dev";
  }
}

// Use dev only if selected AND dev config is available
const wantsDev = getSelectedBackend() === "dev";
const hasDevConfig = !!DEV_CONFIG.apiKey;
if (wantsDev && !hasDevConfig) {
  try {
    localStorage.setItem("tidle-firebase-backend", "prod");
  } catch {}
}
const useDev = wantsDev && hasDevConfig;
const firebaseConfig = useDev ? DEV_CONFIG : PROD_CONFIG;

export const app = initializeApp(firebaseConfig);

// Initialize App Check BEFORE any Firestore/Storage usage
// This ensures App Check tokens are available for all Firebase service calls
initializeFirebaseAppCheck(app);

export const auth = getAuth(app);
export const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache()
});
export const performance = getPerformance(app);
export const storage = getStorage(app); 
export const analytics = getAnalytics(app);

